import { render, staticRenderFns } from "./RedemptionCentral.vue?vue&type=template&id=080ba8ee&scoped=true"
import script from "./RedemptionCentral.vue?vue&type=script&lang=js"
export * from "./RedemptionCentral.vue?vue&type=script&lang=js"
import style0 from "./RedemptionCentral.vue?vue&type=style&index=0&id=080ba8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ba8ee",
  null
  
)

export default component.exports